import { render } from "./DocumentCellDataTableComponent.vue?vue&type=template&id=109c7634&scoped=true"
import script from "./DocumentCellDataTableComponent.vue?vue&type=script&lang=js"
export * from "./DocumentCellDataTableComponent.vue?vue&type=script&lang=js"

import "./DocumentCellDataTableComponent.vue?vue&type=style&index=0&id=109c7634&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109c7634"]])

export default __exports__